const Vue = require('vue');
const Scroll = require('../scroll');

/**
 * ValidateContact
 * @class
 */
class ValidateContact {

  /**
   * @instance
   * @private
   */
  get ERROR_TEXT() {
    return {
      brank    : '入力してください',
      emKana   : '全角カナで入力してください',
      HalfNum  : '半角数字で入力してください',
      email    : 'メールアドレスの形式で入力してください',
      sameEmail: '同じメールアドレスを入力してください',
      tell     : '電話番号を正しく入力してください',
      body     : '全角1,000文字以内で入力してください',
      consent  : '同意するにチェックを入れてください',
    }
  }

  /**
   * @instance
   * @param el {string|HTMLElement} element
   */
  constructor(el) {

    this.el        = el;
    this.nameEl    = this.el.getElementsByClassName('js-validate-contact-name')[0];
    this.kanaEl    = this.el.getElementsByClassName('js-validate-contact-kana')[0];
    this.emailEl   = this.el.getElementsByClassName('js-validate-contact-email')[0];
    this.tellEl    = this.el.getElementsByClassName('js-validate-contact-tell')[0];
    this.bodyEl    = this.el.getElementsByClassName('js-validate-contact-body')[0];
    this.consentEl = this.el.getElementsByClassName('js-validate-contact-consent')[0];

    this.scroll = new Scroll(null, { animeOpts: { offset: -50 } });

    this.vm = new Vue({
      el: this.el,
      data: {
        val: {
          name      : ['', ''],
          kana      : ['', ''],
          email     : '',
          emailCheck: '',
          tell      : ['', '', ''],
          body      : '',
          consent   : '',
        },
        validate: {
          name      : [ false, false ],
          kana      : [ false, false ],
          email     : false,
          emailCheck: false,
          tell      : [ true, true, true ],
          body      : false,
          consent   : false,
        },
        err: {
          name      : [ null, null ],
          kana      : [ null, null ],
          email     : null,
          emailCheck: null,
          tell      : [ null, null, null ],
          body      : null,
          consent   : null,
        },
        isCorrect: false,
      },
      components: {
        'efo': {
          props: ['err'],
          template: '#efo-tmp',
        },
      },
      methods: {
        validateName: (i) => {
          setTimeout(() => {
            this.vdName(i, this.vm.val.name[i]);
          }, 100);
        },
        validateFurigana: (i) => {
          setTimeout(() => {
            this.vdFurigana(i, this.vm.val.kana[i]);
          }, 100);
        },
        validateEmail: () => {
          setTimeout(() => {
            this.vdEmail(this.vm.val.email);
          }, 100);
        },
        validateEmailCheck: () => {
          setTimeout(() => {
            this.vdEmailCheck(this.vm.val.emailCheck);
          }, 100);
        },
        validateTell: (i) => {
          setTimeout(() => {
            this.vdTell(i, this.vm.val.tell[i]);
          }, 100);
        },
        validateBody: () => {
          setTimeout(() => {
            this.vdBody(this.vm.val.body);
          }, 100);
        },
        validateContact: () => {
          setTimeout(() => {
            this.vdContact(this.vm.val.consent);
          }, 100);
        },
        ban: (e) => {
          e.preventDefault();
        },
        submit: (e) => {
          e.preventDefault();
          this.vdAll();
          setTimeout(() => {
            if(this.vm.isCorrect) {
              e.target.submit();
            }
            else {
              this.scrollErrPoint();
            }
          }, 0);
        },

      },
    });

    this.vm.$watch('validate', () => {
      this.setIsCorrect();
    }, { deep: true });

    this.setIsCorrect();
  }

  /**
   * @instance
   * @private
   */
  vdAll() {
    _.forEach(this.vm.val.name, (val, i) => {
      this.vdName(i, val);
    });
    _.forEach(this.vm.val.kana, (val, i) => {
      this.vdFurigana(i, val);
    });
    this.vdEmail(this.vm.val.email);
    this.vdEmailCheck(this.vm.val.emailCheck);
    _.forEach(this.vm.val.tell, (val, i) => {
      this.vdTell(i, val);
    });
    this.vdBody(this.vm.val.body);
    this.vdContact(this.vm.val.consent);
  }

  /**
   * @instance
   * @private
   * @param i {number} index
   * @param val {string}
   */
  vdName(i, val) {
    if(!this.validateRequired(val)) {
      this.vm.err.name.$set(i, this.ERROR_TEXT.brank);
      this.vm.validate.name.$set(i, false);
      return;
    }
    this.vm.err.name.$set(i, null);
    this.vm.validate.name.$set(i, true);
  }

  /**
   * @instance
   * @private
   * @param i {number} index
   * @param val {string}
   */
  vdFurigana(i, val) {
    if(!this.validateRequired(val)) {
      this.vm.err.kana.$set(i, this.ERROR_TEXT.brank);
      this.vm.validate.kana.$set(i, false);
      return;
    }
    if(!this.validateEmKana(val)) {
      this.vm.err.kana.$set(i, this.ERROR_TEXT.emKana);
      this.vm.validate.kana.$set(i, false);
      return;
    }
    this.vm.err.kana.$set(i, null);
    this.vm.validate.kana.$set(i, true);
  }

  /**
   * @instance
   * @private
   * @param val {string}
   */
  vdEmail(val) {
    if(!this.validateRequired(val)) {
      this.vm.err.email = this.ERROR_TEXT.brank;
      this.vm.validate.email = false;
      return;
    }
    if(!this.validateEmailAddress(val)) {
      this.vm.err.email = this.ERROR_TEXT.email;
      this.vm.validate.email = false;
      return;
    }
    this.vm.err.email = null;
    this.vm.validate.email = true;
  }

  /**
   * @instance
   * @private
   * @param val {string}
   */
  vdEmailCheck(val) {
    if(!this.validateRequired(val)) {
      this.vm.err.emailCheck = this.ERROR_TEXT.brank;
      this.vm.validate.emailCheck = false;
      return;
    }
    if(!this.validateEmailAddress(val)) {
      this.vm.err.emailCheck = this.ERROR_TEXT.email;
      this.vm.validate.emailCheck = false;
      return;
    }
    if(val !== this.vm.val.email) {
      this.vm.err.emailCheck = this.ERROR_TEXT.sameEmail;
      this.vm.validate.emailCheck = false;
      return;
    }
    this.vm.err.emailCheck = null;
    this.vm.validate.emailCheck = true;
  }

  /**
   * @instance
   * @private
   * @param i {number} index
   * @param val {string}
   */
  vdTell(i, val) {
    if(val !== '') {
      if(!this.validateHalfNum(val)) {
        this.vm.err.tell.$set(i, this.ERROR_TEXT.HalfNum);
        this.vm.validate.tell.$set(i, false);
        return;
      }
      if(!this.validateStrRenge(val, 1, 5)) {
        this.vm.err.tell.$set(i, this.ERROR_TEXT.tell);
        this.vm.validate.tell.$set(i, false);
        return;
      }
    }
    this.vm.err.tell.$set(i, null);
    this.vm.validate.tell.$set(i, true);
  }

  /**
   * @instance
   * @private
   * @param val {string}
   */
  vdBody(val) {
    if(!this.validateRequired(val)) {
      this.vm.err.body = this.ERROR_TEXT.brank;
      this.vm.validate.body = false;
      return;
    }
    if(!this.validateStrRenge(val, 1, 1000)) {
      this.vm.err.body = this.ERROR_TEXT.body;
      this.vm.validate.body = false;
      return;
    }
    this.vm.err.body = null;
    this.vm.validate.body = true;
  }

  /**
   * @instance
   * @private
   * @param val {boolean}
   */
  vdContact(val) {
    if(!val) {
      this.vm.err.consent = this.ERROR_TEXT.consent;
      this.vm.validate.consent = false;
    }
    else {
      this.vm.err.consent = null;
      this.vm.validate.consent = true;
    }
  }

  /**
   * @instance
   * @private
   * @param val {string}
   */
  validateRequired(val) {
    return (val !== '') ? true : false;
  }

  /**
   * @instance
   * @private
   * @param val {string}
   */
  validateEmKana(val) {
    return val.match(/^[\u30A0-\u30FF]+$/) ? true : false;
  }

  /**
   * @instance
   * @private
   * @param val {string}
   */
  validateEmailAddress(val) {
    return val.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/) ? true : false;
  }

  /**
   * @instance
   * @private
   * @param val {string}
   */
  validateHalfNum(val) {
    return val.match(/^[0-9]+$/) ? true : false;
  }

  /**
   * @instance
   * @private
   * @param val {string}
   */
  validateStrRenge(val, min, max) {
    const len = Math.ceil(this.getCharCount(val) / 2);
    return ((min <= len) && (len <= max)) ? true : false;
  }

  /**
   * @instance
   * @private
   * @param str {string}
   */
  getCharCount(str) {
    let count = 0;
    const escapeStr = escape(str);
    for(let i = 0; i < escapeStr.length; i++, count++) {
      if(escapeStr.charAt(i) === '%') {
        if(escapeStr.charAt(++i) === 'u') {
          i += 3;
          count++;
        }
        i++;
      }
    }
    return count;
  }

  /**
   * @instance
   * @private
   */
  setIsCorrect() {
    const vd = this.vm.validate;

    if(_.every(vd.name, (val) => val) && _.every(vd.kana, (val) => val) &&
       vd.email && vd.emailCheck && _.every(vd.tell, (val) => val) && vd.body && vd.consent) {
      this.vm.isCorrect = true;
    } else {
      this.vm.isCorrect = false;
    }
  }

  /**
   * @instance
   * @private
   */
  scrollErrPoint() {
    const vd   = this.vm.validate;

    if(!_.every(vd.name, (val) => val)){
      this.scroll.run(this.nameEl);
      return;
    }
    if(!_.every(vd.kana, (val) => val)){
      this.scroll.run(this.kanaEl);
      return;
    }
    if(!(vd.email && vd.emailCheck)){
      this.scroll.run(this.emailEl);
      return;
    }
    if(!_.every(vd.tell, (val) => val)){
      this.scroll.run(this.tellEl);
      return;
    }
    if(!vd.body){
      this.scroll.run(this.bodyEl);
      return;
    }
    if(!vd.consent){
      this.scroll.run(this.consentEl);
      return;
    }
  }

}

/**
 * class exports
 */
module.exports = ValidateContact;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/ui/form/validate-contact.js
 **/